import { useEffect, useState } from 'react';
import { TextInput } from '@woocommerce/blocks-components';
import { __ } from '@wordpress/i18n';
import styled from 'styled-components';
import { extensionCartUpdate } from '@woocommerce/blocks-checkout';

export default function GiftForm(props) {
    const { eventRegistration, emitResponse, paymentStatus } = props;
    const { onPaymentSetup, onCheckoutAfterProcessingWithError } = eventRegistration;
    const [cardNumber, setCardNumber] = useState('');
    const [pinNumber, setPinNumber] = useState('');
    const [giftCardNumberError, setGiftCardNumberError] = useState('');

    useEffect(() => {
        const elements = document.querySelectorAll('.wc-block-components-payment-methods__save-card-info');
        // Filter elements to ensure they have the same parent
        const filteredElements = Array.from(elements).filter((element, index, array) => {
            return element.parentElement === array[0].parentElement; // Check if they have the same parent
        });
        if (filteredElements.length > 0) {
            filteredElements[0].style.display = 'none';
        }
        extensionCartUpdate( {
            namespace: 'wc-valorpay-fee-update',
            data: {
                action_type: 'update_payment_type',
                payment_type: "gift",
            },
        } );
        return () => {
            extensionCartUpdate( {
                namespace: 'wc-valorpay-fee-update',
                data: {
                    action_type: 'update_payment_type',
                    payment_type: "",
                },
            } )
            if (filteredElements.length > 0) {
                filteredElements[0].style.display = 'block';
            }
        };
    }, [])

    useEffect( () => {
        const unsubscribe = onPaymentSetup( async () => {
            let isInValidForm = false;
            if ( giftCardNumberError !== '' ) {
                isInValidForm = true;
            }
            if (cardNumber === '') {
                setGiftCardNumberError( __('Please enter a valid Gift Card Number','wc-valorpay'));
                isInValidForm = true;
            }
            if (isInValidForm) {
                return {
                    type: emitResponse.responseTypes.ERROR,
                    message: __(
                        'Please provide payment information',
                        'wc-valorpay'
                    ),
                };
            }
            return {
                type: emitResponse.responseTypes.SUCCESS,
                meta: {
                    paymentMethodData: {
                        wc_valorpay_gift_sale: true,
                        wc_valorpay_gift_card_no: cardNumber.replaceAll(" ", ""),
                        wc_valorpay_gift_card_pin: pinNumber,
                    },
                },
            };
        } );

        
        const unsubscribeErrorMsg = onCheckoutAfterProcessingWithError(
            ( { processingResponse } ) => {
                if ( processingResponse?.paymentDetails?.errorMessage ) {
                    return {
                        type: emitResponse.responseTypes.ERROR,
                        message: processingResponse.paymentDetails.errorMessage,
                        messageContext: emitResponse.noticeContexts.PAYMENTS,
                    };
                }
                // so we don't break the observers.
                return true;
            }
        );
        // Unsubscribes when this component is unmounted.
        return () => {
            unsubscribe();
            unsubscribeErrorMsg();
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onPaymentSetup,
        cardNumber,
        pinNumber,
        giftCardNumberError,
    ] );

    const handleGiftCardNumberChange = (value) => {
        let cardNumber = value.replaceAll(" ", "");
        if ( cardNumber.length <= 21 && /^[0-9]*$/.test(cardNumber) ) {
            let newCardNumber = "";
            let counter = 0;
            for (let n of cardNumber) {
                if ( (counter% 4) === 0) {
                    newCardNumber += " ";
                }
                newCardNumber+=n;
                counter++;
            }
            setCardNumber(newCardNumber);
            setGiftCardNumberError('');
        }
    };

    const handleGiftCardNumberBlur = (event) => {
        if ( cardNumber.length <= 11 ) {
            setGiftCardNumberError( __('Please enter a valid Gift Card Number','wc-valorpay'));
        }
    }

    const handleGiftPinChange = (value) => {
        if ( value.length <= 8 && /^[0-9]*$/.test(value) ) {
            setPinNumber(value);
        }
    };

    return (
        <>
            <TextInput
                id="valor-giftcard-acc-no"
                label={__('Card Number', 'wc-valorpay')}
                feedback={giftCardNumberError === '' ? '' : <div className="wc-block-components-validation-error"><p>{giftCardNumberError}</p></div>}
                type="text"
                value={cardNumber}
                required="true"
                className={giftCardNumberError === '' ? '' : "has-error"}
                onChange={handleGiftCardNumberChange}
                onBlur={handleGiftCardNumberBlur}
            />
            <TextInput
                id="valor-giftcard-pin-no"
                label={__('Pin Number', 'wc-valorpay')}
                type="text"
                value={pinNumber}
                required="false"
                onChange={handleGiftPinChange}
            />
        </>
    )
}